
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "065b1970-d59c-4176-9406-97a3d2823dee"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/home/runner/work/medicalclip-frontend/medicalclip-frontend/medicalclip-frontend/src/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
